import { combineReducers } from 'redux';

import alert from './alert';
import loader from './loader';
import breadcrumb from './breadcrumb';

import auth from './auth';
import dashboard from './dashboard';
import usuarios from './usuarios';
import proveedores from './proveedores';
import configuracion from './configuracion';
import facturas from './facturas';
import inventario from './inventario';
import inventarioCarga from './inventarioCarga';
import clientes from './clientes';
import ventas from './ventas';
import proyectos from './proyectos';
import cotizaciones from './cotizaciones';
import conceptosExternos from './conceptosExternos';
import ordenesSalida from './ordenesSalida';
import ordenesDevolucion from './ordenesDevolucion';
import pagosProyectos from './pagosProyectos';
import pagosVentas from './pagosVentas';

export default combineReducers({
    alert, loader, breadcrumb, auth, dashboard, usuarios, proveedores, configuracion, facturas, inventario, inventarioCarga, clientes, ventas, proyectos, cotizaciones, conceptosExternos, ordenesSalida, ordenesDevolucion, pagosProyectos, pagosVentas
});